<template>
  <div v-show="showBusstopMenu && !busLocationIsOpen" class="absolute right-4 bg-white rounded border border-link px-2 pt-1 pb-2 w-42" :class="getTop()">
    <a @click="closeStopName" class="btn-close is-busstop-info">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-body-lighter"><path fill-rule="evenodd" d="m17.9230769 5 1.0769231 1.07692308-5.9240428 5.92278132 5.9240428 5.9233725-1.0769231 1.0769231-5.9233725-5.9240428-5.92278132 5.9240428-1.07692308-1.0769231 5.9224363-5.9233725-5.9224363-5.92278132 1.07692308-1.07692308 5.92278132 5.9224363z"></path>
      </svg>
    </a>
    <div class="mt-4 mb-2 text-body-light">
      <ul class="busstop-list pt-0.5">
        <li v-for="(selectedBusStop, index) in selectedBusStops" v-bind:key="index">
          <p class="font-bold leading-none">{{ selectedBusStop.stopName }}<br>
            <span class="text-sm font-normal">({{ getCorpName(selectedBusStop.corpName) }})</span>
          </p>
        </li>
      </ul>
    </div>
    <a class="button-primary block w-full button-is-small text-sm" @click="openStopInfo">
      バス停情報を確認
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  data () {
    return {
      showBusstopMenu: false
    }
  },
  methods: {
    openStopInfo: function () {
      this.$store.dispatch('busLocation/openBusLocation')
    },
    closeStopName: function () {
      this.$store.dispatch('busLocation/close')
    },
    getCorpName: function (corpName) {
      return corpName.replace("株式会社","")
    },
    getTop: function () {
      switch (this.selectedBusStops.length) {
        case 1:
          return 'top-56'
        case 2:
          return 'top-52'
        case 3:
          return 'top-48'
        case 4:
          return 'top-44'
        case 5:
          return 'top-40'
        case 6:
          return 'top-36'
        case 7:
          return 'top-32'
        case 8:
          return 'top-28'
        default:
          return 'top-56'
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBusStops: 'busLocation/getSelectedStops',
      busLocationIsOpen: 'busLocation/getIsOpen'
    })
  },
  watch: {
    selectedBusStops: function (val) {
      if (!_.isEmpty(val)) {
        this.showBusstopMenu = true
      } else {
        this.showBusstopMenu = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.busstop-list li:not(:last-child) {
  @apply mb-2;
}
</style>